// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__uKRyZ","vatRate":"styles_vatRate__Pn_tg","vatRateLabel":"styles_vatRateLabel__Wcr7a","slideInSearchBar":"styles_slideInSearchBar__USRzR"};